import { DefaultToastOptions, Toaster } from 'react-hot-toast';

const toastOptions: DefaultToastOptions = {
  position: 'top-center',
  duration: 5000,
  icon: '',
  style: {
    backgroundColor: 'var(--dark-beek-blue)',
    color: 'var(--white)',
    width: '25rem',
    maxWidth: '100%',
  },
  success: {
    style: {
      backgroundColor: 'var(--dark-green)',
    },
  },
  error: {
    duration: 8000,
    style: {
      backgroundColor: 'var(--red)',
    },
  },
};

const Toasts = () => (
  <Toaster position="top-right" toastOptions={toastOptions} />
);
export default Toasts;
